// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from 'E:/zkh/word/PC_word/wp-smart-front/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__index' */'@/layouts/index.js')}),
    "routes": [
      {
        "path": "/aiColor/cardList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiColor__cardList__index' */'@/pages/aiColor/cardList/index.js')})
      },
      {
        "path": "/aiColor/colorCard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiColor__colorCard__index' */'@/pages/aiColor/colorCard/index.js')})
      },
      {
        "path": "/aiColor/colortheme",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiColor__colortheme__index' */'@/pages/aiColor/colortheme/index.js')})
      },
      {
        "path": "/aiColor/prompt",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiColor__prompt__index' */'@/pages/aiColor/prompt/index.js')})
      },
      {
        "path": "/aimodel/aiDress",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aimodel__aiDress__index' */'@/pages/aimodel/aiDress/index.js')})
      },
      {
        "path": "/aimodel/aiGenerateModel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aimodel__aiGenerateModel__index' */'@/pages/aimodel/aiGenerateModel/index.js')})
      },
      {
        "path": "/aimodel/aiStyleColor",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aimodel__aiStyleColor__index' */'@/pages/aimodel/aiStyleColor/index.js')})
      },
      {
        "path": "/aimodel/ModelManage/index copy",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aimodel__ModelManage__index copy' */'@/pages/aimodel/ModelManage/index copy.js')})
      },
      {
        "path": "/aimodel/ModelManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aimodel__ModelManage__index' */'@/pages/aimodel/ModelManage/index.js')})
      },
      {
        "path": "/aimodel/modelMaterial",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aimodel__modelMaterial__index' */'@/pages/aimodel/modelMaterial/index.js')})
      },
      {
        "path": "/aimodel/styleMaterial/index copy",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aimodel__styleMaterial__index copy' */'@/pages/aimodel/styleMaterial/index copy.js')})
      },
      {
        "path": "/aimodel/styleMaterial",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aimodel__styleMaterial__index' */'@/pages/aimodel/styleMaterial/index.js')})
      },
      {
        "path": "/aiService/appManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiService__appManage__index' */'@/pages/aiService/appManage/index.js')})
      },
      {
        "path": "/aiService/FAQ",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiService__FAQ__index' */'@/pages/aiService/FAQ/index.js')})
      },
      {
        "path": "/aiService/knowledge",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiService__knowledge__index' */'@/pages/aiService/knowledge/index.js')})
      },
      {
        "path": "/aiService/messageConfig",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiService__messageConfig__index' */'@/pages/aiService/messageConfig/index.js')})
      },
      {
        "path": "/app/agreement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__app__agreement__index' */'@/pages/app/agreement/index.js')})
      },
      {
        "path": "/app/banner",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__app__banner__index' */'@/pages/app/banner/index.js')})
      },
      {
        "path": "/app/model",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__app__model__index' */'@/pages/app/model/index.js')})
      },
      {
        "path": "/app/prod",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__app__prod__index' */'@/pages/app/prod/index.js')})
      },
      {
        "path": "/app/section",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__app__section__index' */'@/pages/app/section/index.js')})
      },
      {
        "path": "/app/splash",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__app__splash__index' */'@/pages/app/splash/index.js')})
      },
      {
        "path": "/authRedirect",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__authRedirect__index' */'@/pages/authRedirect/index.js')})
      },
      {
        "path": "/enterpriseManage/allocationRule",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__enterpriseManage__allocationRule__index' */'@/pages/enterpriseManage/allocationRule/index.js')})
      },
      {
        "path": "/enterpriseManage/DictManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__enterpriseManage__DictManager' */'@/pages/enterpriseManage/DictManager.js')})
      },
      {
        "path": "/enterpriseManage/ea",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__enterpriseManage__ea__index' */'@/pages/enterpriseManage/ea/index.js')})
      },
      {
        "path": "/enterpriseManage/enterpriseWechat",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__enterpriseManage__enterpriseWechat__index' */'@/pages/enterpriseManage/enterpriseWechat/index.js')})
      },
      {
        "path": "/enterpriseManage/menu",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__enterpriseManage__menu__index' */'@/pages/enterpriseManage/menu/index.js')})
      },
      {
        "path": "/enterpriseManage/organization",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__enterpriseManage__organization__index' */'@/pages/enterpriseManage/organization/index.js')})
      },
      {
        "path": "/enterpriseManage/roles",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__enterpriseManage__roles__index' */'@/pages/enterpriseManage/roles/index.js')})
      },
      {
        "path": "/enterpriseManage/user",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__enterpriseManage__user__index' */'@/pages/enterpriseManage/user/index.js')})
      },
      {
        "path": "/enterpriseManage/userCenter",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__enterpriseManage__userCenter__index' */'@/pages/enterpriseManage/userCenter/index.js')})
      },
      {
        "path": "/home",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__home__index' */'@/pages/home/index.js')})
      },
      {
        "path": "/home/statistics",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__home__statistics__index' */'@/pages/home/statistics/index.js')})
      },
      {
        "path": "/",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index' */'@/pages/index.tsx')})
      },
      {
        "path": "/login",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__login__index' */'@/pages/login/index.js')})
      },
      {
        "path": "/material/article",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__material__article__index' */'@/pages/material/article/index.js')})
      },
      {
        "path": "/material/file",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__material__file__index' */'@/pages/material/file/index.js')})
      },
      {
        "path": "/material/link",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__material__link__index' */'@/pages/material/link/index.js')})
      },
      {
        "path": "/material/materialItem",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__material__materialItem' */'@/pages/material/materialItem.js')})
      },
      {
        "path": "/material/miniprogram",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__material__miniprogram__index' */'@/pages/material/miniprogram/index.js')})
      },
      {
        "path": "/material/picText",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__material__picText__index' */'@/pages/material/picText/index.js')})
      },
      {
        "path": "/material/picture/index copy",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__material__picture__index copy' */'@/pages/material/picture/index copy.js')})
      },
      {
        "path": "/material/picture",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__material__picture__index' */'@/pages/material/picture/index.js')})
      },
      {
        "path": "/material/poster",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__material__poster__index' */'@/pages/material/poster/index.js')})
      },
      {
        "path": "/material/text",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__material__text__index' */'@/pages/material/text/index.js')})
      },
      {
        "path": "/material/video",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__material__video__index' */'@/pages/material/video/index.js')})
      },
      {
        "path": "/member/creditsManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__member__creditsManager__index' */'@/pages/member/creditsManager/index.js')})
      },
      {
        "path": "/member/customerServiceManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__member__customerServiceManage__index' */'@/pages/member/customerServiceManage/index.js')})
      },
      {
        "path": "/member/giftManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__member__giftManager__index' */'@/pages/member/giftManager/index.js')})
      },
      {
        "path": "/member/memberCredits",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__member__memberCredits__index' */'@/pages/member/memberCredits/index.js')})
      },
      {
        "path": "/member/memberEquity",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__member__memberEquity__index' */'@/pages/member/memberEquity/index.js')})
      },
      {
        "path": "/member/memberLever",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__member__memberLever__index' */'@/pages/member/memberLever/index.js')})
      },
      {
        "path": "/member/memberManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__member__memberManager__index' */'@/pages/member/memberManager/index.js')})
      },
      {
        "path": "/operationCenter/index/workbench",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operationCenter__index__workbench__index' */'@/pages/operationCenter/index/workbench/index.js')})
      },
      {
        "path": "/order/afterSalesService",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__afterSalesService__index' */'@/pages/order/afterSalesService/index.js')})
      },
      {
        "path": "/order/freightTemp",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__freightTemp__index' */'@/pages/order/freightTemp/index.js')})
      },
      {
        "path": "/order/orderManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__orderManage__index' */'@/pages/order/orderManage/index.js')})
      },
      {
        "path": "/orderManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__orderManage__index' */'@/pages/orderManage/index.js')})
      },
      {
        "path": "/pageView/editPage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__pageView__editPage__index' */'@/pages/pageView/editPage/index.js')})
      },
      {
        "path": "/pageView/myShop",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__pageView__myShop__index' */'@/pages/pageView/myShop/index.js')})
      },
      {
        "path": "/pageView/pageManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__pageView__pageManage__index' */'@/pages/pageView/pageManage/index.js')})
      },
      {
        "path": "/pageView/splash",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__pageView__splash__index' */'@/pages/pageView/splash/index.js')})
      },
      {
        "path": "/pageView/templageEdit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__pageView__templageEdit__index' */'@/pages/pageView/templageEdit/index.js')})
      },
      {
        "path": "/pageView/templateManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__pageView__templateManage__index' */'@/pages/pageView/templateManage/index.js')})
      },
      {
        "path": "/privateSphere/customer",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__customer__index' */'@/pages/privateSphere/customer/index.js')})
      },
      {
        "path": "/privateSphere/customerAllocation",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__customerAllocation__index' */'@/pages/privateSphere/customerAllocation/index.js')})
      },
      {
        "path": "/privateSphere/customerFriend",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__customerFriend__index' */'@/pages/privateSphere/customerFriend/index.js')})
      },
      {
        "path": "/privateSphere/customerFriend/Statistics/customerStatistice",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__customerFriend__Statistics__customerStatistice' */'@/pages/privateSphere/customerFriend/Statistics/customerStatistice.js')})
      },
      {
        "path": "/privateSphere/customerFriend/Statistics",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__customerFriend__Statistics__index' */'@/pages/privateSphere/customerFriend/Statistics/index.js')})
      },
      {
        "path": "/privateSphere/customerFriend/Statistics/interactiveStatistice",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__customerFriend__Statistics__interactiveStatistice' */'@/pages/privateSphere/customerFriend/Statistics/interactiveStatistice.js')})
      },
      {
        "path": "/privateSphere/customerFriend/Statistics/StaffStatistice",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__customerFriend__Statistics__StaffStatistice' */'@/pages/privateSphere/customerFriend/Statistics/StaffStatistice.js')})
      },
      {
        "path": "/privateSphere/customerGroup/customerGroupDetail/baseDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__customerGroup__customerGroupDetail__baseDetail__index' */'@/pages/privateSphere/customerGroup/customerGroupDetail/baseDetail/index.js')})
      },
      {
        "path": "/privateSphere/customerGroup/customerGroupDetail/CountItem",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__customerGroup__customerGroupDetail__CountItem__index' */'@/pages/privateSphere/customerGroup/customerGroupDetail/CountItem/index.js')})
      },
      {
        "path": "/privateSphere/customerGroup/customerGroupDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__customerGroup__customerGroupDetail__index' */'@/pages/privateSphere/customerGroup/customerGroupDetail/index.js')})
      },
      {
        "path": "/privateSphere/customerGroup",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__customerGroup__index' */'@/pages/privateSphere/customerGroup/index.js')})
      },
      {
        "path": "/privateSphere/greetingTemplate/group",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__greetingTemplate__group' */'@/pages/privateSphere/greetingTemplate/group.js')})
      },
      {
        "path": "/privateSphere/greetingTemplate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__greetingTemplate__index' */'@/pages/privateSphere/greetingTemplate/index.js')})
      },
      {
        "path": "/privateSphere/greetingTemplate/QRCode",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__greetingTemplate__QRCode' */'@/pages/privateSphere/greetingTemplate/QRCode.js')})
      },
      {
        "path": "/privateSphere/greetingTemplate/Staff",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__greetingTemplate__Staff' */'@/pages/privateSphere/greetingTemplate/Staff.js')})
      },
      {
        "path": "/privateSphere/groupMsg/groupMsgDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__groupMsg__groupMsgDetail__index' */'@/pages/privateSphere/groupMsg/groupMsgDetail/index.js')})
      },
      {
        "path": "/privateSphere/groupMsg",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__groupMsg__index' */'@/pages/privateSphere/groupMsg/index.js')})
      },
      {
        "path": "/privateSphere/ShoppingGuide",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__ShoppingGuide__index' */'@/pages/privateSphere/ShoppingGuide/index.js')})
      },
      {
        "path": "/privateSphere/staffQRCode/detailPage/codeDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__staffQRCode__detailPage__codeDetail' */'@/pages/privateSphere/staffQRCode/detailPage/codeDetail.js')})
      },
      {
        "path": "/privateSphere/staffQRCode/detailPage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__staffQRCode__detailPage__index' */'@/pages/privateSphere/staffQRCode/detailPage/index.js')})
      },
      {
        "path": "/privateSphere/staffQRCode/detailPage/Statistics",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__staffQRCode__detailPage__Statistics' */'@/pages/privateSphere/staffQRCode/detailPage/Statistics.js')})
      },
      {
        "path": "/privateSphere/staffQRCode",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__staffQRCode__index' */'@/pages/privateSphere/staffQRCode/index.js')})
      },
      {
        "path": "/privateSphere/tagManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__privateSphere__tagManage__index' */'@/pages/privateSphere/tagManage/index.js')})
      },
      {
        "path": "/productManager/colorBook",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__colorBook__index' */'@/pages/productManager/colorBook/index.js')})
      },
      {
        "path": "/productManager/model",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__model__index' */'@/pages/productManager/model/index.js')})
      },
      {
        "path": "/productManager/productBrand",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productBrand__index' */'@/pages/productManager/productBrand/index.js')})
      },
      {
        "path": "/productManager/productClassify",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productClassify__index' */'@/pages/productManager/productClassify/index.js')})
      },
      {
        "path": "/productManager/productGroup",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productGroup__index' */'@/pages/productManager/productGroup/index.js')})
      },
      {
        "path": "/productManager/productManager/AIGenerationModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__AIGenerationModal__index' */'@/pages/productManager/productManager/AIGenerationModal/index.js')})
      },
      {
        "path": "/productManager/productManager/ColorBookModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__ColorBookModal' */'@/pages/productManager/productManager/ColorBookModal.js')})
      },
      {
        "path": "/productManager/productManager/ColorList/index copy",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__ColorList__index copy' */'@/pages/productManager/productManager/ColorList/index copy.js')})
      },
      {
        "path": "/productManager/productManager/ColorList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__ColorList__index' */'@/pages/productManager/productManager/ColorList/index.js')})
      },
      {
        "path": "/productManager/productManager/CreateProductModalForm/GoupModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__CreateProductModalForm__GoupModal__index' */'@/pages/productManager/productManager/CreateProductModalForm/GoupModal/index.js')})
      },
      {
        "path": "/productManager/productManager/CreateProductModalForm",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__CreateProductModalForm__index' */'@/pages/productManager/productManager/CreateProductModalForm/index.js')})
      },
      {
        "path": "/productManager/productManager/CreateProductModalForm/PriceInventoryModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__CreateProductModalForm__PriceInventoryModal__index' */'@/pages/productManager/productManager/CreateProductModalForm/PriceInventoryModal/index.js')})
      },
      {
        "path": "/productManager/productManager/CreateProductModalForm/PriceInventoryModal/PropertyItem",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__CreateProductModalForm__PriceInventoryModal__PropertyItem__index' */'@/pages/productManager/productManager/CreateProductModalForm/PriceInventoryModal/PropertyItem/index.js')})
      },
      {
        "path": "/productManager/productManager/CreateProductModalForm/PriceInventoryModal/PropertyItem/item",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__CreateProductModalForm__PriceInventoryModal__PropertyItem__item' */'@/pages/productManager/productManager/CreateProductModalForm/PriceInventoryModal/PropertyItem/item.js')})
      },
      {
        "path": "/productManager/productManager/CreateProductModalForm/PropertyModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__CreateProductModalForm__PropertyModal__index' */'@/pages/productManager/productManager/CreateProductModalForm/PropertyModal/index.js')})
      },
      {
        "path": "/productManager/productManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__index' */'@/pages/productManager/productManager/index.js')})
      },
      {
        "path": "/productManager/productManager/ModelSkuForm",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__ModelSkuForm__index' */'@/pages/productManager/productManager/ModelSkuForm/index.js')})
      },
      {
        "path": "/productManager/productManager/PreviewColorCard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__PreviewColorCard__index' */'@/pages/productManager/productManager/PreviewColorCard/index.js')})
      },
      {
        "path": "/productManager/productManager/UploadColorCard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__UploadColorCard__index' */'@/pages/productManager/productManager/UploadColorCard/index.js')})
      },
      {
        "path": "/productManager/productManager/UploadList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productManager__UploadList__index' */'@/pages/productManager/productManager/UploadList/index.js')})
      },
      {
        "path": "/productManager/productProperty",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productProperty__index' */'@/pages/productManager/productProperty/index.js')})
      },
      {
        "path": "/productManager/productSpecs",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productSpecs__index' */'@/pages/productManager/productSpecs/index.js')})
      },
      {
        "path": "/productManager/productTag",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productTag__index' */'@/pages/productManager/productTag/index.js')})
      },
      {
        "path": "/productManager/productTag/TagCategory",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productTag__TagCategory__index' */'@/pages/productManager/productTag/TagCategory/index.js')})
      },
      {
        "path": "/productManager/productTag/TagTable",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__productManager__productTag__TagTable__index' */'@/pages/productManager/productTag/TagTable/index.js')})
      },
      {
        "path": "/site",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__site__index' */'@/pages/site/index.js')})
      },
      {
        "path": "/site/:type?",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__site__type$' */'@/pages/site/[type$].js')})
      },
      {
        "path": "/statistics/behavior",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__statistics__behavior__index' */'@/pages/statistics/behavior/index.js')})
      },
      {
        "path": "/statistics/product",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__statistics__product__index' */'@/pages/statistics/product/index.js')})
      },
      {
        "path": "/statistics/user",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__statistics__user__index' */'@/pages/statistics/user/index.js')})
      },
      {
        "path": "/user/profile",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__profile__index' */'@/pages/user/profile/index.js')})
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
